import auth from '@/Middlewares/auth.js'
import ResourceRoute from '@/Setup/Routes/ResourceRoute.js'
import RouteGroup from '@/Setup/Routes/RouteGroup.js'

export const paymentAccountRoutes = new RouteGroup(() => {
  return [
    ...new ResourceRoute('payment-accounts', {
      list: () => import(/* webpackChunkName: "payments" */ './Pages/List.vue'),
    })
      .only(['list'])
      .permissions({
        list: 'payment-accounts.view',
      })
      .resolve(),
  ]
})
  .middlewares([auth])
  .resolve()
